import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import styled from "styled-components"

const InfoTitle = styled(Typography).attrs({ as: "h1" })`
  font-size: 26px;
  font-weight: 300;
  letter-spacing: 1px;
  margin-bottom: 18px;
  text-transform: capitalize;
  text-align: center;
`

const InfoLayout = ({ children, layout, title }) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {layout && (
        <Box contain mt={4} px={{ _: "10px", tablet: 2 }}>
          <InfoTitle>{title}</InfoTitle>
        </Box>
      )}
      {children}
    </>
  )
}

InfoLayout.propTypes = {
  children: PropTypes.element.isRequired,
  layout: PropTypes.string,
  title: PropTypes.string,
}

export default InfoLayout
